export enum UserType {
  app = 'app',
  card_active = 'card_active',
  card_passive = 'card_passive',
}
